import { createAsyncThunk } from '@reduxjs/toolkit'
import RestClient from '../../../services/client/RestClient'
import Configuration from '../../../services/api/Configuration'

const getTitlesApi = Configuration.Titles_Endpoints.titles

const retrieveTitles = createAsyncThunk('titles/getTitles', async () => {
  const res = await RestClient.getRequest(`${getTitlesApi}`)
  return res.data
})

export default retrieveTitles
